"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Somali
var strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: 'kahor',
  suffixFromNow: 'kadib',
  seconds: 'sikino',
  minute: 'daqiiqad',
  minutes: '%d daqiiqo',
  hour: 'saac',
  hours: '%d saacadood',
  day: 'maalin',
  days: '%d maalmood',
  month: 'bil',
  months: '%d bilood',
  year: 'sano',
  years: '%d sano',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;